<template>
  <div class="step-two" :style="{height: viewportHeight}">
    <HomeHeader scroll-top="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div class="flex-column main">
        <div class="title">企业MCN机构申请</div>
        <div class="steps-box">
          <el-steps :active="2" align-center>
            <el-step title="选择公会类型"></el-step>
            <el-step title="填写公会信息"></el-step>
            <el-step title="填写资质信息"></el-step>
            <el-step title="确认信息"></el-step>
            <el-step title="等待审核"></el-step>
            <el-step title="完成入驻"></el-step>
          </el-steps>
        </div>
        <div class="form-box">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-form-item v-if="oneStepDetail.mcnType === 1" label="" label-width="0">
              <div style="font-weight: bold;width: 100px;text-align: right;font-size: 16px;">企业资质</div>
            </el-form-item>
            <el-form-item v-if="oneStepDetail.mcnType === 1" label="营业执照" prop="businessLicenseUrl">
              <div>
                <div class="flex-row-h-center ">
                  <directUploadOne
                      model="img"
                      size="10MB"
                      :imgUrl.sync="ruleForm.businessLicenseUrl"/>
                  <div style="margin-left: 10px;">文件格式仅支持png、jpeg，大小不超过10M</div>
                </div>
                <BusinessLicense></BusinessLicense>
              </div>
            </el-form-item>
            <el-form-item v-if="oneStepDetail.mcnType === 1" label="企业名称" prop="businessLicenseName">
              <el-input v-model.trim="ruleForm.businessLicenseName" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item v-if="oneStepDetail.mcnType === 1" label="其他许可证">
              <directUploadMultiple
                  model="img"
                  :limit="9"
                  size="10MB"
                  :file-list.sync="ruleForm.otherLicenseList"/>
              <div>
                <div class="flex-row">
                  <div>文件格式仅支持png、jpeg，大小不超过10M</div>
                </div>
                <CertificateDec></CertificateDec>
              </div>
            </el-form-item>
            <el-form-item label="" label-width="0" prop="name">
              <div style="font-weight: bold;width: 100px;text-align: right;font-size: 16px;">主播信息</div>
            </el-form-item>
            <el-form-item label="签约主播数量" prop="anchorAmount">
              <el-input-number
                  style="width: 60%"
                  v-model="ruleForm.anchorAmount"
                  controls-position="right"
                  :step="1"
                  :min="5"
                  :precision="0"
                  placeholder="请输入"
                  :max="9999999999"></el-input-number>
            </el-form-item>
            <el-form-item label="签约主播证明材料">
              <directUploadMultiple
                  model="img"
                  :limit="9"
                  size="10MB"
                  :file-list.sync="ruleForm.anchorEvidentiaryList"/>
              <div>
                <div class="flex-row">
                  <div>文件格式仅支持png、jpeg，大小不超过10M</div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="签约主播来源" prop="anchorSource">
              <div>
                <el-input
                    type="textarea"
                    v-model.trim="ruleForm.anchorSource"
                    maxlength="200"
                    show-word-limit
                    rows="8"
                    placeholder="请输入"></el-input>
              </div>
              <div>示例：好友推荐、市场签约</div>
            </el-form-item>
            <el-form-item>
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="default"
                      @click="onPre()">上一步
                  </el-button>
                </el-col>
                <el-col :span="8">
                  <el-button
                      style="width: 100%"
                      type="primary"
                      @click="submitForm()">下一步
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {joinApplyProgress, stepTwoSave} from "@/apis/audit";
import BusinessLicense from './components/business-license'
import CertificateDec from './components/certificate-dec'
import {validateText2} from "@/utils/validate";

export default {
  name: "select-type",
  components: {
    HomeHeader,
    BusinessLicense,
    CertificateDec
  },
  data() {
    return {
      oneStepDetail: {}, // 第一步申请信息
      viewportHeight: '100vh',
      imgCodeUrl: '', // 图形验证码
      imgKey: '', // 图形验证码的key
      ruleForm: {
        businessLicenseUrl: "", // 营业执照，为企业类型时必填 false
        businessLicenseName: "", // 企业名称，为企业类型时必填 false
        otherLicenseList: ['http://localhost:9557/img/business-license.1faa5053.png'], // 其他许可证 false

        anchorAmount: 5, // 签约主播数量 true
        anchorEvidentiaryList: [],	// 签约主播证明材料 false
        anchorSource: "", // 主播来源 false
      },
      rules: {
        businessLicenseUrl: [
          {required: true, message: '请输入', trigger: 'change'}
        ],
        businessLicenseName: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        anchorAmount: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    if (this.$route.query.mcnType) {
      this.ruleForm.mcnType = this.$route.query.mcnType
      this.oneStepDetail.mcnType = this.$route.query.mcnType
    }
    this.joinApplyProgressApi()
  },
  mounted() {
    let viewportHeight = document.documentElement.clientHeight;
    this.viewportHeight = viewportHeight + 'px'
  },
  methods: {
    // 获取申请进度
    joinApplyProgressApi() {
      const applyId = localStorage.getItem('applyId')
      if (!applyId) {
        return
      }
      joinApplyProgress({applyId}).then(res => {
        const data = res.data || {}
        this.oneStepDetail = data
        if (data.mcnType) {
          this.ruleForm.mcnType = data.mcnType
          this.oneStepDetail.mcnType = data.mcnType
        }
        this.ruleForm.businessLicenseUrl = data.businessLicenseUrl || ''
        this.ruleForm.businessLicenseName = data.businessLicenseName || ''
        this.ruleForm.otherLicenseList = data.otherLicenseList || []
        this.ruleForm.anchorAmount = data.anchorAmount || ''
        this.ruleForm.anchorEvidentiaryList = data.anchorEvidentiaryList || []
        this.ruleForm.anchorSource = data.anchorSource || ''
      })
    },
    // 返回上一步
    onPre() {
      this.$confirm('离开当前页面，数据将会丢失, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.replace({
          path: '/apply/step-one',
          query: {
            mcnType: this.oneStepDetail.mcnType
          }
        })
      })
    },
    // 提交表单
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.ruleForm.businessLicenseName && !validateText2(this.ruleForm.businessLicenseName)) {
            return this.$message({
              message: '企业名称只能包含中英文和数字',
              type: 'warning'
            })
          }
          this.stepTwoSaveApi()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    stepTwoSaveApi() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      stepTwoSave({
        version: this.oneStepDetail.version || 0, // 版本号
        ...this.ruleForm
      }).then(res => {
        if (res.data && typeof res.data === "boolean" && res.data === false) {
          this.$message.warning('数据已更新，正在为您刷新页面')
          return setTimeout(() => {
            this.$router.go(0)
          }, 2000)
        }
        console.log(res)
        this.$router.push({
          path: '/apply/confirm-info'
        })
      }).catch((err) => {
        if (err.data && typeof err.data === "boolean" && err.data === false) {
          setTimeout(() => {
            this.$router.go(0)
          }, 2000)
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 返回上一步
    goStepOne(type) {
      this.$router.push({
        path: '/apply/step-one',
        query: {
          mcnType: type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.step-two {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .back {
    padding: 16px 16px 16px 0;
    width: max-content;
    font-size: 16px;
    cursor: pointer;
  }

  .main {
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px 0;
    border-radius: 4px;
    background-color: #ffffff;

    .steps-box {
      width: 800px;
      margin: 0 auto;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      margin: 20px 0 0;
      padding: 30px 240px 20px;
    }

    .title {
      margin-bottom: 30px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }
  }
}
</style>